module.exports = __webpack_public_path__ + "assets/98b7934be328141f31ee9001ba9efa61.png";